import * as angular from 'angular';
import { config } from 'angular/utils/config';

export class ReportingService {
    REPORT = {
        AUCTION: {
            PDF: '/auctions/pdf',
            CSV: '/auctions/csv'
        },
        UPLOAD: {
            PAGE: 'app/reporting/upload-report.html',
            PDF: '/uploads/pdf',
            CSV: '/uploads/csv'
        },
        FCFS: {
            PAGE: 'app/reporting/fcfs-report.html',
            PDF: '/fcfs/pdf'
        },
        SECONDARY: {
            PAGE: 'app/reporting/secondary-report.html',
            TRADE: {
                PDF: '/secondary-trade/pdf'
            },
            PROPOSAL: {
                PDF: '/proposal/pdf'
            },
            EXTERNAL_TRADE: {}
        },
        SURRENDER: {},
        CONTRACTS: {
            PAGE: 'app/reporting/contract-positions-report.html',
            PDF: '/fcfs/legalContractPositions/pdf'
        }
    };

    /**
     * Reporting
     *
     * @returns {Object} An object with methods and attributes served by the service.
     * @author flzemke.btc
     * @ngInject
     */
    CHARGE = {
        MEASUREMENT: 'MEASUREMENT',
        BIOGAS: 'BIOGAS',
        OPERATION: 'OPERATION',
        ACCOUNTING: 'ACCOUNTING',
        GAS_QUALITY_CONVERSION: 'GAS_QUALITY_CONVERSION',
        AUCTION_SURCHARGE: 'AUCTION_SURCHARGE',
        TOTAL: 'TOTAL',
        BILLING: 'BILLING',
        BALACING_CHARGE: 'BALACING_CHARGE',
        COMMODITY_FEE: 'COMMODITY_FEE'
    };

    TRANSACTION_TYPE = {
        AUCTION: 'AUCTION',
        UPLOAD: 'UPLOAD',
        FCFS: 'FCFS',
        REVERSE_AUCTION: 'REVERSE_AUCTION',
        SURRENDER: 'SURRENDER',
        SECONDARY: 'SECONDARY'
    };

    mapCharges(charges0, charges1) {
        if (!charges0) {
            charges0 = [];
        }
        if (!charges1) {
            charges1 = [];
        }

        return {
            measurementCharge0: this.getChargeByEnum(
                this.CHARGE.MEASUREMENT,
                charges0
            ),
            measurementCharge1: this.getChargeByEnum(
                this.CHARGE.MEASUREMENT,
                charges1
            ),
            biogasCharge0: this.getChargeByEnum(this.CHARGE.BIOGAS, charges0),
            biogasCharge1: this.getChargeByEnum(this.CHARGE.BIOGAS, charges1),
            operatingCharge0: this.getChargeByEnum(
                this.CHARGE.OPERATION,
                charges0
            ),
            operatingCharge1: this.getChargeByEnum(
                this.CHARGE.OPERATION,
                charges1
            ),
            accountingCharge0: this.getChargeByEnum(
                this.CHARGE.ACCOUNTING,
                charges0
            ),
            accountingCharge1: this.getChargeByEnum(
                this.CHARGE.ACCOUNTING,
                charges1
            ),
            gasQualityConversionCharge0: this.getChargeByEnum(
                this.CHARGE.GAS_QUALITY_CONVERSION,
                charges0
            ),
            gasQualityConversionCharge1: this.getChargeByEnum(
                this.CHARGE.GAS_QUALITY_CONVERSION,
                charges1
            ),
            balancingCharge0: this.getChargeByEnum(
                this.CHARGE.BALACING_CHARGE,
                charges0
            ),
            balancingCharge1: this.getChargeByEnum(
                this.CHARGE.BALACING_CHARGE,
                charges1
            ),
            commodityFee0: this.getChargeByEnum(
                this.CHARGE.COMMODITY_FEE,
                charges0
            ),
            commodityFee1: this.getChargeByEnum(
                this.CHARGE.COMMODITY_FEE,
                charges1
            )
        };
    }

    getChargeByEnum(enumeration, charges) {
        for (let i = 0; i < charges.length; i++) {
            const obj1 = charges[i];
            if (obj1.type === enumeration) {
                return obj1.priceDto;
            }
        }
    }

    mapExportUrls(report, type) {
        if (this.isValidReportType(report) && type == 'PDF') {
            return config.monolithApi + report[type];
        } else if (this.isValidReportType(report) && type == 'CSV') {
            return config.monolithApi + report[type];
        }
        return null;
    }

    isValidReportType(report) {
        return (
            report == this.REPORT.AUCTION ||
            report == this.REPORT.UPLOAD ||
            report == this.REPORT.FCFS ||
            report == this.REPORT.SECONDARY.TRADE ||
            report == this.REPORT.SECONDARY.PROPOSAL ||
            report == this.REPORT.CONTRACTS
        );
    }
}

angular.module('app').service('reportingService', ReportingService);
